import { userChangeForgottenPasswordSuccess, userChangeForgottenPasswordError } from "./reducer"
import * as AuthApi from "../../../services/authApi";
import { loginSuccess } from "../login/reducer";

export const userChangeForgottenPassword = (data, { router }) => async (dispatch) => {
  try {
    const response = await AuthApi.changeForgottenPassword({
      code: data.code,
      password: data.password,
      passwordConfirmation: data.passwordConfirmation
    });

    if(response.jwt && response.user) {
        dispatch(userChangeForgottenPasswordSuccess(
            "Password changed successfully. You will be logged in shortly."
        ))

        localStorage.setItem("authUser", JSON.stringify(response));
        dispatch(loginSuccess(response));

        setTimeout(() => {
            router.navigate("/dashboard");
        }, 1500);
    } else {
        dispatch(userChangeForgottenPasswordError(response.error))
    }
  } catch (changeForgetError) {
      dispatch(userChangeForgottenPasswordError(changeForgetError))
  }
}